export function buildWsUrl(baseUrl: string, path: string) {
  const httpReplaced = baseUrl.replace(/^http/, "ws").replace(/\/$/, "");
  return `${httpReplaced}${path}`;
}
